import React, { useEffect, useRef, useState } from 'react';
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

export default function PassSlider(props) {
  const originalPosters = Array.from(
    { length: 17 },
    (_, i) => `/images/pass/poster${String(i + 1).padStart(2, '0')}.png`
  );

  const swiperRef = useRef(null);
  const [key, setKey] = useState(0);

  useEffect(() => {
    let timeoutId;

    const handleOrientationChange = () => {
      // 화면 회전 감지 후 약간의 지연을 두고 Swiper 재시작
      timeoutId = setTimeout(() => {
        if (swiperRef.current && swiperRef.current.swiper) {
          const swiper = swiperRef.current.swiper;

          // Swiper 업데이트 및 재시작
          swiper.update();
          swiper.updateSize();
          swiper.updateSlides();

          // autoplay 재시작
          if (swiper.autoplay) {
            swiper.autoplay.start();
          }

          // 컴포넌트 강제 리렌더링 (필요시)
          setKey(prev => prev + 1);
        }
      }, 300); // 화면 회전 완료 후 300ms 대기
    };

    // 화면 회전 및 리사이즈 이벤트 리스너
    window.addEventListener('orientationchange', handleOrientationChange);
    window.addEventListener('resize', handleOrientationChange);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('orientationchange', handleOrientationChange);
      window.removeEventListener('resize', handleOrientationChange);
    };
  }, []);

  console.log(props.lang);

  return (
    <>
      <div className="passSectionTitleWrap_type3">
        <em className="passSectionTitle">
          {props.lang === 'en' ? (
            <>
              All these channels<br />
              One <em>SBS play Pass</em> is enough!
            </>
          ) : (
            <>
              이 모든 채널<br />
              <em>SBS play 이용권</em> 하나면 충분해요!
            </>
          )}
        </em>
      </div>

      <div className="passSlider_w">
        <Swiper
          ref={swiperRef}
          key={key}
          className="slider swiper-container"
          modules={[Autoplay, Pagination]}
          slidesPerView={3}
          loop={true}
          centeredSlides={true}
          spaceBetween={12}
          allowTouchMove={false}
          pagination={{
            el: ".swiper-pagination",
            clickable: true
          }}
          speed={2000}
          autoplay={{
            delay: 0,
            enabled: true,
            disableOnInteraction: false,
          }}
          observer={true}
          observeParents={true}
          watchOverflow={true}
          updateOnWindowResize={true}
          breakpoints={{
            640: { slidesPerView: 5 },
            768: { slidesPerView: 6 },
            1024: { slidesPerView: 7 },
            1440: { slidesPerView: 8 }
          }}
        >
          {originalPosters.map((src, idx) => (
            <SwiperSlide className="slide swiper-slide" key={idx}>
              <img src={src} alt={`poster${idx + 1}`} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
}